import AccountFactory from './account/AccountFactory'
import WechatFactory from './factory/WechatFactory'
import { IS_SMART_DEVICE } from './utils/device'
import { PUBLIC_PATH } from './config/index'

class Start {
  /**
   * 启动项目
   */
  static run () {
    window.log = function () {}
    Start.debug()
    Start.switchView()
    // 尝试初始化微信openid
    WechatFactory.tryInitOpenId()

    // 初始化token
    AccountFactory.initToken()
  }

  // 切换模式
  static switchView () {
    const path = (process.env.NODE_ENV === 'production') ? PUBLIC_PATH : '/'
    const host = window.location.host
    const publicPath = PUBLIC_PATH
    const publishUrl = `${host}${publicPath}` // 's.21rv.com/reserve/'
    const url = window.location.href
    const str = `${path}web`
    const isWeb = url.indexOf(str) > 0

    // 移动端打开web时
    if (IS_SMART_DEVICE && isWeb) {
      const [, a] = url.split(`${publishUrl}web/`)
      return window.location.replace(`${PUBLIC_PATH}${a || ''}`)
    }
    // web端打开移动时
    if (!IS_SMART_DEVICE && !isWeb) {
      const [, a] = url.split(`${publishUrl}`)
      return window.location.replace(`${PUBLIC_PATH}web/${a || ''}`)
    }
  }

  // 开启debug
  static debug () {
    const ele = document.createElement('div')
    ele.id = 'logs'
    ele.draggable = true
    document.body.appendChild(ele)

    window.log = function (...str) {
      const el = document.getElementById('logs')
      const tag = document.createElement('p')
      tag.innerHTML = str.toString()
      el.appendChild(tag)
    }
  }
}

export default Start
